import './clubPrepaid.css';

import React, {useEffect, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import GoBackArrow from "../../../components/GoBackArrow";
import Container from "../../../components/Container";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import Spinner from "../../../components/Spinner";
import YourBalance from "../components/YourBalance";
import BuyMoreBags from "../components/BuyMoreBags";
import {CaddieService} from "../../../services/api/CaddieService";

interface Props {

}

const ClubPrepaidBagDashboard = ({}: Props) => {

    const { club } = handicaddieSelector(state => state.clubs.selected)
    const { user } = handicaddieSelector(state => state.session)

    const { getCaddiesForUser } = CaddieService()

    const [balance, setBalance] = useState<number | undefined>()

    useEffect(() => {
        setBalance(undefined)
        if (!user || !club) {
            return;
        }

        getBalance(club.id, user.id)
    }, [club, user]);

    const getBalance = async (clubId: string, userId: string) => {
        let resp = await getCaddiesForUser(userId);
        if (!resp || !resp.caddies) {
            return;
        }

        resp.caddies
            .filter(caddie => caddie.clubId === clubId)
            .forEach((caddie) => {
                if (caddie.userId === userId && caddie.clubId === clubId) {
                    setBalance(caddie.prepaidBagBalance)
                }
            })
    }

    if (!club) {
        return <>
            <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <Container>
                <GoBackArrow />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spinner onBackground />
                </div>
            </Container>
        </>
    }

    return (
        <>
            <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <Container>
                <GoBackArrow />

                <p className={"heading"}>{club.name}</p>

                <YourBalance balance={balance} />
                <BuyMoreBags />
            </Container>
        </>
    )
}

export default ClubPrepaidBagDashboard;